import React from "react";
import { useTranslation } from "react-i18next";
import {gql, useMutation, useQuery} from "@apollo/client";
import {useState} from "react";
import ParticipantList from "./ParticipantList";
import SearchField from "./SearchField";
import GroupName from "./GroupName";
import {useRouter} from "next/router";
import ModalComponent from "../ModalComponent";

const GET_ORG_USERS = gql`
    query OrganizationUsersQuery {
        users {
            id
            firstName
            lastName
            username
        }
    }
`;

const CREATE_MESSAGING_GROUP = gql`
    mutation MyMutation2($members: [uuid] = "", $roomName: String = "") {
        createMessagingGroup(members: $members, roomName: $roomName) {
            id
        }
    }
`;

// const Transition = React.forwardRef(function Transition(props, ref) {
// 	return <Fade ref={ref} {...props} />;
// });

const GroupMessageDialog = ({open, handleClose}) => {
	const { t } = useTranslation();
	const router = useRouter();
	const [createMessagingGroup, { data: dataCreateMessagingGroup, loading: loadingCreateMessagingGroup, errorCreateMessagingGroup }] = useMutation(CREATE_MESSAGING_GROUP);
	const { loading: loadingUsers, error: errorUsers, data: dataUsers } = useQuery(GET_ORG_USERS);
	const [groupName, setGroupName] = useState("");
	const [participants, setParticipants] = useState([]);
	const [groupNameError, setGroupNameError] = useState(false);
	const [participantsError, setParticipantsError] = useState(false);

	const handleRemove = (value) => {
		setParticipants(participants.filter((participant) => participant.id !== value.id));
	};

	const resetAndClose = () => {
		setParticipants((participants) => []);
		setGroupName("");
		setGroupNameError(false);
		setParticipantsError(false);
		handleClose();
	};

	const handleParticipantClick = (user) => {
		if (participants.some((participant) => user.id === participant.id)) {
			handleRemove(user);
		}
		else {
			setParticipants([...participants, {id: user.id, firstName: user.firstName, lastName: user.lastName}]);
		}
	};

	const handleResetParticipantsClick = () => {
		setParticipants([]);
	};

	const groupMessageCreated = (data) => {
		resetAndClose();
		if (data?.createMessagingGroup?.id) {
			router.push("/message/" + data?.createMessagingGroup?.id);
		}
	};

	const handleOkClick = () => {
		const invalidName = !groupName.trim();
		const invalidParticipants = participants.length === 0;

		setGroupNameError(invalidName);
		setParticipantsError(invalidParticipants);

		if (!invalidName && !invalidParticipants) {
			createMessagingGroup({ variables: {
				members: participants.map((participant) => participant.id),
				roomName: groupName
			}}).then((res) => groupMessageCreated(res.data)).catch((e) => console.error(e));
		}
	};

	if (loadingUsers) return (<div />);
	if (errorUsers) { return <div>{errorUsers.message}</div>; }
	if (dataUsers) {}

	return (
		<ModalComponent
			open={open}
			handleClose={resetAndClose}
			handleOk={handleOkClick}
			title={t("Create group")}
		>
			<GroupName
				value={groupName}
				setGroupName={setGroupName}
				error={groupNameError}
			/>
			<SearchField
				error={participantsError}
				users={dataUsers.users}
				participants={participants}
				handleParticipantClick={(user) => handleParticipantClick(user)}
				handleResetParticipantsClick={handleResetParticipantsClick}
			/>
			{participants.length > 0 &&
				<ParticipantList
					participants={participants}
					handleRemove={handleRemove}
				/>
			}
		</ModalComponent>
	);
};

export default GroupMessageDialog;
